export const headers = [
  { name: 'Indicador', field: 'indicator.name', sortable: true, custom: true },
  { name: 'Chave Pix', field: 'indicator.bank_pix_key', sortable: false },
  { name: 'Contratos', field: 'contracts', sortable: false, custom: true },
  { name: 'Valor', field: 'value_comission', sortable: false, custom: true },
  { name: 'Valor pago', field: 'paid_value', sortable: false, custom: true },
  { name: 'Pago em', field: 'paid_date', sortable: false, custom: true },
  { name: 'Situação', field: 'situation', sortable: false, custom: true },
  { name: 'Criado em', field: 'created_at', sortable: false, custom: true },
  { name: 'Ações', field: 'actions', sortable: false, custom: true }
]
